import { render, staticRenderFns } from "./setup.vue.html?vue&type=template&id=e8244e4e"
import script from "./setup.controller?vue&type=script&lang=js&external"
export * from "./setup.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports